__turbopack_context__.v({
  "colorD20": "StarsRating-module-scss-module__JWix-a__colorD20",
});
